import React, { FunctionComponent } from "react";

import { Box, Button, MobileStepper } from "@mui/material";
import { KeyboardArrowRight, KeyboardArrowLeft } from "@mui/icons-material";

type CarouselProps = {
  images: string[];
  placeholder?: string;
};

export const Carousel: FunctionComponent<CarouselProps> = ({
  images,
  placeholder,
}) => {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#FAFAFA",
      }}
    >
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          paddingLeft: 15,
          paddingRight: 15,
        }}
      >
        <img
          src={images.length > 0 ? images[activeStep] : placeholder}
          style={{
            width: "100%",
            height: undefined,
            objectFit: "contain",
            aspectRatio: 4 / 3,
          }}
        />
      </Box>
      <MobileStepper
        variant="dots"
        steps={images.length || 1}
        position="static"
        activeStep={activeStep}
        sx={{
          maxWidth: 400,
          flexGrow: 1,
          width: "100%",
          backgroundColor: "#FAFAFA",
        }}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep >= images.length - 1}
          >
            <KeyboardArrowRight />
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            <KeyboardArrowLeft />
          </Button>
        }
      />
    </Box>
  );
};
